import { useTenderDeadline } from "../../../../hooks/useTenderDeadline";
import React, { useId } from 'react';
import cn from "classnames";
import style from "../common.module.scss"
import { ORDER_STATUSES_DATA } from '../../../../mock';
import BallIcon from '../../../shared/icons/BallIcon';
import { useTranslation } from 'react-i18next';
import AppTooltip from '../../../shared/AppTooltip/AppTooltip';
import InfoIcon from '../../../shared/icons/InfoIcon';
import { useSelector } from 'react-redux';

const SELECTION_COMPLETED_COLOR = "#6D7885";
const AUCTION_IN_PROGRESS_COLOR = "#1212b1";

const EXPEDITOR_NAME_HIDDEN_STATUSES = [
  'awaitingoffer',
  'assigned',
  'canceled',
  'expeditorrejected',
  'booked',
  'published',
];

const OrdersSectionItemTableStatus = ({
  status,
  driverName,
  driverSurname,
  expeditorName,
  expeditorId,
  isExpeditor = false,
  tenderDateEnd,
  assignmentMethod,
  requiresAction = false,
  timeSnapshotKey,
}) => {
  const { isExpired: isTenderExpiredByServer } = useTenderDeadline(tenderDateEnd, { inclusive: true, refreshKey: timeSnapshotKey ?? tenderDateEnd });
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const userCompanyId = user?.companyId ?? user?.company?.id;
  const tooltipId = `orders-section-expeditor-tooltip-${useId().replace(/:/g, "")}`;
  const orderStatusesData = ORDER_STATUSES_DATA(t);
  const isTenderExpired = tenderDateEnd ? isTenderExpiredByServer : false;
  const statusKey =
    status === "awaitingoffer" && isTenderExpired && !isExpeditor ? "awaitingaction" : status;
  const statusColor = orderStatusesData[statusKey]?.color;
  const assignmentStatusTitle =
    statusKey === "awaitingoffer"
      ? {
          Tender: t("ordersAvailablePage.tenderInProgress"),
          Auction: t("ordersAvailablePage.auctionInProgress"),
        }[assignmentMethod]
      : null;
  const isSelectionCompleted = Boolean(
    isExpeditor &&
      status?.toLowerCase() !== "awaitingoffer" &&
      expeditorId != null &&
      expeditorId !== "" &&
      userCompanyId != null &&
      userCompanyId !== "" &&
      String(expeditorId) !== String(userCompanyId),
  );
  const statusTitle = isSelectionCompleted
    ? t("ordersAvailablePage.selectionCompleted")
    : assignmentStatusTitle || orderStatusesData[statusKey]?.title || status;
  const assignmentStatusColor =
    statusKey === "awaitingoffer" && assignmentMethod === "Auction"
      ? AUCTION_IN_PROGRESS_COLOR
      : statusColor;
  const statusDisplayColor = isSelectionCompleted
    ? SELECTION_COMPLETED_COLOR
    : assignmentStatusColor;

  const showExpeditorName =
    expeditorName && !EXPEDITOR_NAME_HIDDEN_STATUSES.includes(status?.toLowerCase());

  const setSummary = (status) => {
    switch (status) {
      case 'moderation': return t("orderInfo.orderHistory.summaryModeration");
      case 'published': return
      case 'waitstarttrip': return ""
      case 'awaitingpayment': return ""
      case 'waitingforcompletion': return
      case 'inprocess': return
      case 'onthetrip': return
      case 'waitloadingcargo': return
      case 'completed': return 
      case 'rejectedunloadingcargomoderation': return
      case 'unloadingcargomoderation': return
      case 'processunloadingcargo': return t("orderInfo.orderHistory.summaryProcessUnloading");
      case 'processloadingcargo': return t("orderInfo.orderHistory.summaryProcessLoading");
      case 'unloadingcargo': return
      case 'loadingcargo': return
      case 'waitcompletion': return
      case 'canceled': return
      case 'booked': return `${driverSurname} ${driverName}`;
      case 'rejected': return
      case 'confirmed': return
      case 'awaitingOffer': return t("orderInfo.orderHistory.summaryAwaitingOffer");
      case 'assigned': return t("orderInfo.orderHistory.summaryAssigned");

      default: return '';
    }
  };

  return (
    <div className={cn(style.table_col)}>
      <div className={cn(style.status_lineTitle)} style={{ color: statusDisplayColor }}>
        <BallIcon fill={statusDisplayColor} />
        {statusTitle}
      </div>
      <div className={style.status_summary}>
        {isSelectionCompleted ? null : showExpeditorName ? (
          <>
            <span data-tooltip-id={tooltipId}>{expeditorName}</span>
            <AppTooltip id={tooltipId} positionStrategy="fixed" delayShow={50}>
              {expeditorName}
            </AppTooltip>
          </>
        ) : (
          setSummary(status)
        )}
      </div>
      {requiresAction && !isSelectionCompleted && (
        <div className={style.status_actionRequired}>
          <InfoIcon color="#C84620" width="20" height="20" />
          {t("ordersAvailablePage.actionRequired")}
        </div>
      )}
    </div>
  );
};

export default OrdersSectionItemTableStatus;
